import React, { useEffect, useState } from 'react';
import { getFormModAndID } from './gridFormUtils';
import Api from 'app/services/api';
import { useSnackbar } from 'notistack';
import SmartGridForm from './SmartGridForm';
import { useNavigate, useLocation } from 'react-router-dom';
import { pick } from 'lodash';
import { translate } from 'translate';

function sanitize(data) {
  for (const key in data) {
    if (Object.hasOwnProperty.call(data, key)) {
      const element = data[key];
      if (element === '') delete data[key];
    }
  }
  return data;
}

const CrudGridForm = ({
  path,
  name,
  fields,
  entityName,
  title,
  onAdd,
  extraSubmitData,
  onChange,
  defaultValues,
}) => {
  const { mod, uuid } = getFormModAndID();
  const [entity, setEntity] = useState();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();

  // console.log(location.pathname)

  if (!extraSubmitData) {
    extraSubmitData = {};
  }

  const [submitLoading, setSubmitLoading] = useState(false);

  const onSubmit = async (data) => {
    try {
      setSubmitLoading(true);
      if (mod === 'add') {
        console.log(data);
        console.log('extra', extraSubmitData);
        data.uuid = uuid;
        await Api.post(path, sanitize({ ...data, ...extraSubmitData }));

        enqueueSnackbar(translate(name) + ' ' + translate('successfully added'), {
          variant: 'success',
        });
        if (onAdd) {
          onAdd();
        } else {
          setTimeout(() => {
            navigate(location.pathname.replace('/add', ''));
          }, 500);
        }
      } else if (mod === 'edit') {
        const picked = pick(
          data,
          fields.map((f) => f.key),
        );
        await Api.put(`${path}/${uuid}`, sanitize(picked));

        enqueueSnackbar(translate(name) + ' ' + translate('successfully edited'), {
          variant: 'success',
        });
        setTimeout(() => {
          navigate(location.pathname.replace(/\/edit.*/, ''));
        }, 500);
      }
    } catch (e) {
      enqueueSnackbar(translate(e) || translate('something went wrong'), { variant: 'error' });
    } finally {
      setSubmitLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      if (mod === 'edit') {
        const data = await Api.get(`${path}/${uuid}`);
        setEntity(data);
        // reset(data)
      } else {
        setEntity({});
      }
    })();
  }, []);

  useEffect(() => {
    if (mod === 'add' && JSON.stringify(defaultValues) != JSON.stringify(entity)) {
      setEntity(undefined);
      setTimeout(() => {
        setEntity(defaultValues);
      }, 1);
    }
  }, [defaultValues]);

  return (
    <>
      {entity && (
        <SmartGridForm
          fields={fields.filter((f) => (f.mod ? f.mod === mod : true))}
          onSubmit={onSubmit}
          entity={entity}
          name={name}
          entityName={entityName}
          onChange={onChange}
          title={
            title
              ? title
              : mod === 'add'
              ? `افزودن ${translate(name)}`
              : `ویرایش ${translate(name)}`
          }
        />
      )}
    </>
  );
};

export default CrudGridForm;
